import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Aux, Heading6, Icon, TitleIcon, Validator } from "../widgets";
import { uuid, validateCollections } from "../../helpers/common";
import { createScaleDevice, updateScaleDeviceInfo } from "../../actions/scale-device";
import { useDispatch, useSelector } from "react-redux";


const AddDeviceModal = ({
  show,
  setShow,
  isEdited,
  editScaleId,
  setEditModal,
  setEditScaleId }) => {

  const dispatch = useDispatch();
  const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
  const scaleInfo = useSelector(state => state.scaleDevice.scaleInfo);

  const scaleDetails = validateCollections(scaleInfo) ? scaleInfo : [];
  const filteredScaleInfo = scaleDetails.filter(it => it.scale_device_uuid === editScaleId);

  const [farmData, setFarmData] = useState({
    scaleDeviceId: "",
    scaleDeviceName: ""
  });

  const generateUuid = () => {
    const id = uuid();
    setFarmData(prev => ({ ...prev, scaleDeviceId: id }));
  }
  const clearGenId = () => {
    setFarmData(prev => ({ ...prev, scaleDeviceId: "" }));
  }

  const handleChange = (e) => {
    const farmInputs = { ...farmData, [e.target.name]: e.target.value };
    setFarmData(farmInputs);
  }

  const handleSave = () => {
    const params = {
      farm_uuid: farmId,
      scale_device_uuid: farmData.scaleDeviceId,
      scale_device_name: farmData.scaleDeviceName
    }
    if (isEdited) {
      dispatch(updateScaleDeviceInfo(params));
    } else {
      dispatch(createScaleDevice(params));
    }
    setEditModal(false);
    setShow(false);
    setEditScaleId("");
    setFarmData({
      scaleDeviceId: "",
      scaleDeviceName: ""
    });
  }

  const handleClose = () => {
    setEditScaleId("");
    setShow(false);
    setEditModal(false);
    setFarmData({
      scaleDeviceId: "",
      scaleDeviceName: ""
    });
  }

  useEffect(() => {
    if (isEdited && editScaleId) {
      const scaleDeviceName = filteredScaleInfo[0].name ? filteredScaleInfo[0].name : "";
      const scaleDeviceId = filteredScaleInfo[0].scale_device_uuid ? filteredScaleInfo[0].scale_device_uuid : "";
      setFarmData(prev => ({ ...prev, scaleDeviceId, scaleDeviceName }));
    }
  }, [isEdited, editScaleId]);

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" className="modal-form">
      <Form className="eg-form m-1">
        <Modal.Header closeButton>
          <Modal.Title>
            <Heading6>
              <TitleIcon className="fa fa-mobile" />
              Add Scale Device
            </Heading6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <Aux>
            <Form.Group>
              <Validator validation={true}>
                <Form.Label htmlFor="deviceId">Scale Device Id <Validator.Mand /></Form.Label>
                <div className='d-flex'>
                  <Form.Control id="scaleDeviceId" disabled={isEdited} type="text" style={{ width: "100%" }} placeholder="Enter the device id" className="form-control" autoComplete="off"
                    value={farmData.scaleDeviceId} name="scaleDeviceId" onChange={(e) => handleChange(e)} maxLength={36} />
                  <div className='d-flex ml-2 mt-1'>
                    <Button variant='info' disabled={isEdited} title='Generate Id' size='sm' onClick={() => generateUuid(farmData.deviceId)} ><i className="fa fa-plus-circle"></i></Button>
                    <Button className='ml-1' disabled={isEdited} variant='danger' title='Clear' size='sm' onClick={clearGenId}><i className="fa fa-trash"></i></Button>
                  </div>
                </div>
                <Validator.Text />
              </Validator>
            </Form.Group>
          </Aux>
          <Aux>
            <Form.Group>
              <Form.Label htmlFor="hardwareTypeId">Scale Device Name</Form.Label>
              <Form.Control id="scaleDeviceName" type="text" placeholder="Enter the device name" className="form-control" autoComplete="off"
                value={farmData.scaleDeviceName} name="scaleDeviceName" onChange={(e) => handleChange(e)} maxLength={36} />
            </Form.Group>
          </Aux>
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="danger" disabled={!farmData.scaleDeviceName} className="mr-2" onClick={handleClose}>
            <Icon className="fa fa-times"></Icon> Cancel</Button>
          <Button size="sm" variant="primary" disabled={!farmData.scaleDeviceName} onClick={handleSave}>
            <Icon className="fa fa-floppy-o"></Icon> Save</Button>
        </Modal.Footer>
      </Form>
    </Modal>)
}

export default AddDeviceModal;